import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";
import { SkeletonRows } from "./SkeletonRows.jsx";

export function AccountDetailSkeleton() {
  const { c } = useThemeSlice();

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
      <div style={{ padding: "14px 18px", borderBottom: `1px solid ${c.divider}`, display: "flex", alignItems: "center", gap: 12 }}>
        <SkeletonBlock width={32} height={32} radius={8} />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
          <SkeletonBlock width={200} height={20} />
          <SkeletonBlock width={140} height={13} />
        </div>
        <SkeletonBlock width={80} height={32} radius={8} />
        <SkeletonBlock width={80} height={32} radius={8} />
      </div>
      <div style={{ display: "flex", gap: 4, padding: "0 18px", borderBottom: `1px solid ${c.divider}` }}>
        {[1, 2, 3, 4, 5].map((i) => (
          <SkeletonBlock key={i} width={72} height={36} radius={0} style={{ marginBottom: -1 }} />
        ))}
      </div>
      <div style={{ flex: 1, padding: "14px 18px 18px" }}>
        <SkeletonRows count={5} height={48} gap={10} />
      </div>
    </div>
  );
}
